module.exports = __webpack_public_path__ + "static/media/inter.c27028bc.png";